import {combineReducers} from "redux"

import NavKey from "./NavKey"
import CompanyModal from "./CompanyModal"
import CaseDetailsInfo from "./CaseDetailsInfo"
import TagKey from "./TagKey"
import ChangeCompanyModal from "./ChangeCompanyModal"

const rootReducers=combineReducers({
    NavKey,
    CompanyModal,
    CaseDetailsInfo,
    TagKey,
    ChangeCompanyModal
});
export default rootReducers


// WEBPACK FOOTER //
// ./src/reducers/index.js